import {
  apiGet,
  apiPost,
  apiDelete,
  apiDownloadPost,
} from '../../api/index';
import { urlStudentSubjects } from '../../api/urls';

export function fetchStudentSubjects(showAll, params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  const endpoint = showAll ? 'all' : 'all-my-subjects';
  return apiPost(`${urlStudentSubjects}/${endpoint}`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function fetchStudentsBySubject({ subjectId, onSuccess, onError }) {
  return apiGet(`${urlStudentSubjects}/inscription-students/${subjectId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function moveExamInscriptionsByExam({ data, onSuccess, onError }) {
  return apiPost(`${urlStudentSubjects}/move-inscription-exams-by-exam`, data)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchMySubject({ id, onSuccess, onError }) {
  return apiGet(`${urlStudentSubjects}/my/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}
export function fetchStudentSubject({ id, onSuccess, onError }) {
  return apiGet(`${urlStudentSubjects}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function saveStudentSubject(data, callback) {
  return apiPost(`${urlStudentSubjects}`, data)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function saveStudentSubjects(data, callback) {
  return apiPost(`${urlStudentSubjects}/save-inscription`, data)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function moveStudentSection({ data, onSuccess, onError }) {
  return apiPost(`${urlStudentSubjects}/move-inscription`, data)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function deleteStudentSubject(id, { onSuccess, onError }) {
  return apiDelete(`${urlStudentSubjects}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchAllMallas(params) {
  return apiGet(`${urlStudentSubjects}/active-mallas`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function fetchAllSemesters(params) {
  return apiGet(`${urlStudentSubjects}/active-semesters`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function fetchAllSubjects(params) {
  return apiGet(`${urlStudentSubjects}/subjects`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function getFormDatas({
  isNew, perfilAlumnoId, onSuccess, onError,
}) {
  const method = isNew ? 'new-inscription-form-data' : `inscription-form-data/${perfilAlumnoId}`;
  return apiGet(`${urlStudentSubjects}/${method}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function getInscriptionAllSubjects({ onSuccess, onError, mallaId }) {
  return apiGet(`${urlStudentSubjects}/inscription-all-subjects/${mallaId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }

      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchAllSubjectsBySemesters(params) {
  return apiGet(`${urlStudentSubjects}/subjects_by_semesters/${params.perfilAlumnoId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function actualizarNotas(inscripcion, { onSuccess, onError }) {
  return apiPost(`${urlStudentSubjects}/actualizar_notas`, inscripcion)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function reporteAlumnosPorMateria(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlStudentSubjects}/reporte_alumnos_por_materia`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function descargarReporteAlumnosPorMaterias(params) {
  const filters = params.filters || {};
  return apiDownloadPost(`${urlStudentSubjects}/reporte_alumnos_por_materia_download`, filters)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Reporte de Asistencia y PP.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (params && params.onSuccess) params.onSuccess(blob);
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function obtenerMisDerechos({
  pageInfo = ({ page: 1, pageSize: 1000 }),
  onSuccess,
  onError,
}) {
  return apiPost(`${urlStudentSubjects}/mis_derechos_a_examenes`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function addToFavorites(inscripcion, callback) {
  return apiPost(`${urlStudentSubjects}/add_subject_dashboard`, inscripcion)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}
